import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function OrderDetailProgressBar(props) {
    const classes = useStyles();
    let totalPieces = 0;
    let progress = props.productionOrder.bomOut[0].quantityProduced;
    let percentage1 = "0%";
    let percentage2 = "0%";
    let percentage3 = "0%";
    let firstBorder = "";
    let secondBorder = "";
    let marge = 1;
    let borderRadiusBlue = "5px 0px 0px 5px";
    let borderRadiusGray = "0px 5px 5px 0px";
    if (props.productionOrder) {

        totalPieces = props.productionOrder.bomOut[0].quantityToProduce
      
        // if(parseInt(props.productionOrder.progress) > 0){
        //      progress =  Math.ceil(parseInt(props.productionOrder.progress) / piecesPerPallet)
        // }

        if (progress === 0) {
            borderRadiusGray = "5px"
        }

        if (progress < 10) {
            marge = 0.2
        } else if (progress < 100) {
            marge = 0.5
        }

        percentage1 = String(progress / totalPieces * 100) + "%"
        percentage2 = String(100 - progress / totalPieces * 100) + "%"
        percentage3 = String(progress / totalPieces * 100 - marge) + "%"

        if (progress === 0) {
            percentage1 = "0%"
            percentage3 = "0%"
        }

        if (percentage1 === "100%") {
            firstBorder = "1px solid " + FlagstoneTheme.palette.primary.main
            borderRadiusBlue = "5px"
        } else {
            secondBorder = "1px solid " + FlagstoneTheme.palette.primary.main
        }
    }

    return <div className={classes.orderDetailProgressBar}>

        <div className={classes.numberPart}>
            <div className={classes.pushingPart} style={{ width: percentage3 }}>
            </div>
            <div className={classes.number} style={{ width: percentage2,position:"relative", right:"1px" }}>
                {progress}
            </div>
        </div>
        <div className={classes.selectionPart}>
            <div className={classes.emptyPart} style={{ width: percentage1, borderRight: firstBorder }}>
            </div>
            <div className={classes.borderPart} style={{ width: percentage2, borderLeft: secondBorder }}>
            </div>
        </div>
        <div className={classes.barPart}>
            <div className={classes.blueBarPart} style={{ width: percentage1, borderRadius: borderRadiusBlue }}>
            </div>
            <div className={classes.grayBarPart} style={{ width: percentage2, borderRadius: borderRadiusGray }}>
            </div>
        </div>
        <div className={classes.range}>
            <div className={classes.min}>
            0
            </div>
            <div className={classes.max}>
                {totalPieces}
            </div>
        </div>

    </div>
}

const useStyles = makeStyles({

    OrderDetailProgressBar: {
        display: 'block'
    },
    blueBarPart: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        float: "left",
        height: "7px",

    },
    grayBarPart: {
        backgroundColor: "#DEDEDE",
        float: "left",
        height: "7px",
    },
    borderPart: {
        float: "left",
        height: "7px",
        boxSizing: "border-box",
    },
    emptyPart: {
        float: "left",
        height: "7px",
    },
    barPart: {
        height: "7px",
        width: "100%",
        paddingLeft: "3%",
        paddingRight: "3%",
        marginTop: "3px",
        boxSizing: "border-box",
        display: "block"
    },
    selectionPart: {
        display: "block",
        height: "7px",
        width: "100%",
        paddingLeft: "3%",
        paddingRight: "3%",
        marginTop: "2px",
        boxSizing: "border-box",
    },
    numberPart: {

        display: "block",
        height: "15px",
        width: "100%",
        paddingLeft: "3%",
        paddingRight: "3%",
        boxSizing: "border-box",

    },
    pushingPart: {
        float: "left",
        height: "15px",
    },
    number: {
        float: "left",
        height: "15px",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
    },
    min: {
        float: "left",
        height: "15px",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
    }, max: {
        float: "right",
        height: "15px",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
    },
    range: {
        display: 'block',
        height: "15px",
        paddingLeft: "3%",
        paddingRight: "1.7%",
    },

});